var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdduserGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#1B998B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 23C22.7956 23 23.5587 22.6839 24.1213 22.1213C24.6839 21.5587 25 20.7956 25 20C25 19.2044 24.6839 18.4413 24.1213 17.8787C23.5587 17.3161 22.7956 17 22 17C21.2044 17 20.4413 17.3161 19.8787 17.8787C19.3161 18.4413 19 19.2044 19 20C19 20.7956 19.3161 21.5587 19.8787 22.1213C20.4413 22.6839 21.2044 23 22 23ZM22 25C23.5913 25 25.1174 25.6321 26.2426 26.7574C27.3679 27.8826 28 29.4087 28 31H16C16 29.4087 16.6321 27.8826 17.7574 26.7574C18.8826 25.6321 20.4087 25 22 25ZM30 21C30 20.7348 29.8946 20.4804 29.7071 20.2929C29.5196 20.1054 29.2652 20 29 20C28.7348 20 28.4804 20.1054 28.2929 20.2929C28.1054 20.4804 28 20.7348 28 21V22H27C26.7348 22 26.4804 22.1054 26.2929 22.2929C26.1054 22.4804 26 22.7348 26 23C26 23.2652 26.1054 23.5196 26.2929 23.7071C26.4804 23.8946 26.7348 24 27 24H28V25C28 25.2652 28.1054 25.5196 28.2929 25.7071C28.4804 25.8946 28.7348 26 29 26C29.2652 26 29.5196 25.8946 29.7071 25.7071C29.8946 25.5196 30 25.2652 30 25V24H31C31.2652 24 31.5196 23.8946 31.7071 23.7071C31.8946 23.5196 32 23.2652 32 23C32 22.7348 31.8946 22.4804 31.7071 22.2929C31.5196 22.1054 31.2652 22 31 22H30V21Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdduserGreen);
export default __webpack_public_path__ + "static/media/adduser-green.ac79428a.svg";
export { ForwardRef as ReactComponent };